// src/App.tsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LoginForm from "./components/LoginForm";
import RegisterPage from "./components/RegisterPage";
import AppLayout from "./layouts/AppLayout";
import { useAuth } from "./context/AuthContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ForgotPasswordPage from "./components/ForgotPasswordPage";
import ResetPasswordPage from "./components/ResetPasswordPage";
import RegisterCompany from "./RegisterCompany";
import CompanyAdminLogin from "./components/CompanyAdminLogin";
import CompanyAddUser from "./CompanyAddUser";
//import SuperAdminAssignProject from "./SuperAdminAssignProject";
import { UIProvider } from "./context/UIContext";
import GanttStandalone from "./components/gantt/GanttStandalone";
import MarkwiseProgressReport from "./components/WorksReport/MarkwiseProgressReport";

// ✅ ADD THIS (outside component)
const queryClient = new QueryClient();
export default function App() {
 
  const { token,initialized } = useAuth();
  //page load
  if (!initialized) {
  return null; // or a loader
}
  const userType = localStorage.getItem("userType"); // ✅ ADD

  return (
    // ✅ WRAP ROUTES HERE
    <QueryClientProvider client={queryClient}>
    <Routes>
      <Route path="/" element={token ? <AppLayout /> : <Navigate to="/login" replace />} />
      
      <Route path="/login" element={<LoginForm />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/register-company" element={<RegisterCompany />} />
      <Route path="/company-admin-login" element={<CompanyAdminLogin />} />
      {/*<Route path="/add-user" element={<CompanyAddUser />} />*/}

     <Route
  path="/add-user"
  element={
    <UIProvider>
      <CompanyAddUser />
    </UIProvider>
  }
/>


       {/* ✅ ADD THIS ROUTE */}
      {/*  <Route
          path="/super-admin"
          element={
            userType === "superadmin"
              ? <SuperAdminAssignProject />
              : <Navigate to="/login" replace />
          }
        />*/}
       {/* <Route
  path="/super-admin"
  element={
    token && userType?.toLowerCase() === "superadmin"
      ? <SuperAdminAssignProject />
      : <Navigate to="/login" replace />
  }
/>*/}
{/* ✅ ADD THIS ROUTE */}
        <Route path="/gantt" element={<GanttStandalone />} />
        <Route path="/gantt-print" element={<GanttStandalone />} />

        <Route path="/markwise-progress" element={<MarkwiseProgressReport />} />


      {/* Optional: catch-all */}
      <Route path="*" element={<Navigate to={token ? "/" : "/login"} replace />} />
      {/*<Route path="/register" element={<RegisterPage />} />*/}

    </Routes>
    </QueryClientProvider>
  );
}
